import http from './http'

export default {
  getIncoming: params => http.get('/v2/reports/incoming', { params }),
  getIncomingPdf: reportId => http.get(`/v2/reports/incoming/${reportId}/pdf`, { silent: true }),
  getOutgoingPdf: reportId => http.get(`/v2/reports/outgoing/${reportId}/pdf`, { silent: true }),
  getIncomingTotals: params => http.get('/v2/reports/incoming/totals', { params }),
  getOutgoing: params => http.get('/v2/reports/outgoing', { params }),
  getOutgoingTotals: params => http.get('/v2/reports/outgoing/totals', { params }),
  getOutgoingOptions: () => http.get('/v2/reports/outgoing/options'),
  exportIncoming: params => http.get('/v2/reports/incoming/export', { params, responseType: 'blob' }),
  exportOutgoing: params => http.get('/v2/reports/outgoing/export', { params, responseType: 'blob' }),
  updateIncomingAmount: (reportId, data) => http.patch(`/v2/reports/incoming/${reportId}/amount`, data, { silent: true, localSuccess: true }),
  updateOutgoingAmount: (invoiceId, data) => http.patch(`/v2/reports/outgoing/invoices/${invoiceId}/amount`, data, { silent: true, localSuccess: true }),
  generateOutgoing: (draftId, data) => http.post(`/v2/drafts/${draftId}/reports/outgoing/generate`, data, { silent: true }),
  generationStatus: draftId => http.get(`/v2/drafts/${draftId}/reports/outgoing/generation-status`),
  queueStatus: draftId => http.get(`/v2/drafts/${draftId}/reports/outgoing/queue-status`),
  generateOutgoingAba: data => http.post('/v2/reports/outgoing/aba', data, { silent: true, responseType: 'blob' }),
  updatePaymentType: data => http.patch('/v2/reports/outgoing/payment-type', data, { silent: true, localSuccess: true }),
  updatePaymentStatus: data => http.patch('/v2/reports/outgoing/payment-status', data, { silent: true, localSuccess: true }),
  updateRefunds: data => http.patch('/v2/reports/outgoing/refunds', data, { silent: true, localSuccess: true }),
  downloadVehiclesPdf: draftId => http.get(`/v2/drafts/${draftId}/reports/nominations-with-vehicles/pdf`, { responseType: 'blob' })
}



// WEBPACK FOOTER //
// ./src/services/api/reports.js